import { useState, useEffect } from 'react';
import { loadCalendarEvents } from '../services/calendarApi';

export const useCalendarEvents = (currentUser, isLoading, autoUpdate) => {
  const [events, setEvents] = useState([]);

  // 初回スケジュール取得
  useEffect(() => {
    if (!isLoading) {
      const fetchEvents = async () => {
        try {
          const loadedEvents = await loadCalendarEvents();
          setEvents(Array.isArray(loadedEvents) ? loadedEvents : []);
        } catch (error) {
          console.error('スケジュール取得エラー:', error);
          setEvents([]);
          if (error.message.includes('認証')) {
            alert('認証エラーが発生しました。ログインしてください。');
          }
        }
      };
      fetchEvents();
    }
  }, [isLoading, currentUser]);

  // 自動更新
  useEffect(() => {
    let intervalId;
    if (autoUpdate) {
      intervalId = setInterval(async () => {
        try {
          const loadedEvents = await loadCalendarEvents();
          setEvents(Array.isArray(loadedEvents) ? loadedEvents : []);
        } catch (error) {
          console.error('自動更新中にエラー:', error);
        }
      }, 5000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [autoUpdate]);

  return {
    events,
    setEvents
  };
};